import React from 'react'
import Trans from 'next-translate/Trans'
import { ReactSVG } from 'react-svg'
import { copyToClipboard } from 'tennders-stracture/libs/utils'
import { useToast } from 'tennders-common/hooks/useToast'
import useTranslation from 'next-translate/useTranslation'

const CustomerRefNumber = ({ cRefNumber }) => {
  const { t } = useTranslation()
  const { toastSuccess } = useToast()

  return (
    <div className="d-flex align-center text-12 mb-0">
      <Trans i18nKey="financePage:customerRefNo" />:
      <span className="ml-2">{cRefNumber}</span>
      <div
        className="tennders-copy-icon cursor-pointer mt-2"
        onClick={() => {
          copyToClipboard(cRefNumber)
          toastSuccess(t('common:copied'))
        }}
      >
        <ReactSVG
          src="/img/icon-copy.svg"
          className="icon-small"
        />
      </div>
    </div>
  )
}
export default CustomerRefNumber
